import React, { useEffect, useMemo, useState } from 'react';
import { Menu, LayoutGrid } from 'lucide-react';
import { useMenuContext } from '../../context';
import { EMenuOpenType } from '../../types';
import Button from './Button';
import Container from './Container';
import { Tooltip } from './Tooltip';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  hasBeenOpened: boolean;
  menuIsOpen: boolean;
  item?: any;
  top?: number;
  index: number;
  isFirst?: boolean;
  isLast?: boolean;
  libraryIconsBaseUrl: string;
  awsIconUrl: string;
};

export default function BMTriggerButton({
  onOpen,
  onClose,
  setMenuIsOpen,
  hasBeenOpened,
  menuIsOpen,
  item,
  top,
  index,
  isFirst,
  isLast,
  libraryIconsBaseUrl,
  awsIconUrl,
}: Props) {
  const { settings, openType, open, colors, translation } = useMenuContext();
  const { typeView, icon, iconFile, tourId, id } = item;

  const [leftOffset, setLeftOffset] = useState(148);
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const tooltipOn = useMemo(
    () => settings.tooltipOnBm && !hasBeenOpened && index === 0,
    [settings.tooltipOnBm, hasBeenOpened, index],
  );

  useEffect(() => {
    if (!tooltipOn) return;

    if (tooltipRef.current?.offsetWidth) {
      setLeftOffset(tooltipRef.current?.offsetWidth + 58);
    }
  }, [tooltipOn, tooltipRef.current?.offsetWidth]);

  return (
    <Container hasBeenOpened={hasBeenOpened} tooltipOn={!!tooltipOn} leftOffset={leftOffset} top={top}>
      {tooltipOn && (
        <Tooltip
          ref={tooltipRef}
          label={translation?.menuAppointmentTooltip || 'Menu'}
          hasBeenOpened={hasBeenOpened}
          bgColor={colors.bmBg}
          textColor={colors.bmText}
        />
      )}
      <Button
        onOpen={onOpen}
        onClose={onClose}
        active={open ? openType === EMenuOpenType.BM : false}
        setMenuIsOpen={setMenuIsOpen}
        icon={typeView === 'list' ? <Menu /> : <LayoutGrid />}
        customIcon={icon ? `${libraryIconsBaseUrl}/${icon}?hex=${encodeURIComponent(colors.bmText || "#fff")}` : iconFile ? `${awsIconUrl}/${tourId}/parentMenus/icons/${iconFile}` : ''}
        menuIsOpen={menuIsOpen}
        hasBeenOpened={hasBeenOpened}
        bgColor={colors.bmBg}
        textColor={colors.bmText}
        openOnHover={settings.openOnHoverBm}
        isFirst={isFirst}
        isLast={isLast}
        isBM
      />
    </Container>
  );
}
